module.exports = __webpack_public_path__ + "static/img/5.41ef921.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/01/5.png
// module id = UgwN
// module chunks = 1